const ALL_BUILDINGS = {
  id: 0,
  label: 'All Buildings',
};

export default ALL_BUILDINGS;
